var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeadStatusesPage',{attrs:{"title":_vm.__('Status concluído', 'settings'),"description":_vm.__('status que definem uma lead como concluída', 'settings'),"param-id":"lead_statuses_completed"}})
}
var staticRenderFns = []

export { render, staticRenderFns }